import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { goToPage } from '../../WifiManagementBlockSlice';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import guestIcon from './images/guest-icon.svg';

const GuestNetworkInfoPage = (props) => {
    //const [isChecked, setIsChecked] = useState(false);
    //const [isShowPassword, setIsShowPassword] = useState(false);

    useEffect(() => {

    }, []);

    return (
        <div className='guest-network-info-page'>

            <div className='guest-icon' style={{backgroundImage:guestIcon.bg()}}></div>
            <div className='title'> רשת אורחים </div>
            <div className='guest-text'>
                רשת אורחים מאפשרת למבקרים שלך לגשת לאינטרנט מבלי לחשוף את הרשת הראשית שלך, בכך שומרת על ה-Wi-Fi הביתי והנתונים האישיים שלך בטוחים
            </div>

            <div className='button-wrapper'>
                <BtnSubmit text='הפעל רשת אורחים' onclick={handleGoToNetworkType} formid='guest-network-info' />
            </div>
        </div>
    );


    function handleGoToNetworkType() {
        props.goToPage('networkTypePage');
    }

};

const mapStateToProps = (state) => {
    return {
        
    };
};

const mapDispatchToProps = {
    goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(GuestNetworkInfoPage);